import { Component, OnInit,Inject } from '@angular/core';
import { ExcelViewerService } from 'src/app/repository/service/excel-viewer.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';




@Component({
  selector: 'app-remove-topcut',
  templateUrl: './remove-topcut.component.html',
  styleUrls: ['./remove-topcut.component.scss']
})
export class RemoveTopcutComponent implements OnInit {

  public selectedTopcut:any;
  public selectedTopcutOptions:any = [];
  public selectedOption:any = [];
  public isSelectedTopcutOptionsOpen:boolean = false;
  public topcutHeaderText:string;


  constructor(
    public evService:ExcelViewerService,
    public notifier:NotifierService,
    @Inject(MAT_DIALOG_DATA)
    public data:{openPopupType:string,headerText:string,sameLevelAlltopCutContainer:any[]},
  ) { }

  ngOnInit(): void {
    if(this.data && this.data.openPopupType == 'addTopcut'){
      setTimeout(() =>{
        this.getSelectedTopcutOption();
      },10)

    }
    // console.log(this.data.sameLevelAlltopCutContainer,'Great');
  }


  getSelectedTopcutOption(){
    this.selectedTopcutOptions = [];
    this.selectedTopcut = this.data.sameLevelAlltopCutContainer.find((va:any) => va['name'] === this.data.headerText);
    if(this.selectedTopcut){
      Object.keys(this.selectedTopcut['options']).forEach((key) =>{
        let options = {};
        options['name'] = this.selectedTopcut['options'][key]['name'];
        options['keyId'] = key;
        this.selectedTopcutOptions.push(options);
      })
      // console.log(this.selectedTopcutOptions);
    }

  }


  getAllTopcutText(){
    let topcut = [];
    this.data.sameLevelAlltopCutContainer.forEach(item =>{
      topcut.push(item['name']);
    })
    return topcut.join(',');
  }


  switchTopCutOptionsShow(){
    // console.log(this.isSelectedTopcutOptionsOpen);
    this.isSelectedTopcutOptionsOpen  = !this.isSelectedTopcutOptionsOpen;

  }


  checkedForSelectedOptions(opt:any){
    let index = this.selectedOption.findIndex((va:any) => (va['keyId'] === opt['keyId'] && va['name'] === opt['name']));
    if(index == -1){
      this.selectedOption.push(opt);
    }else{
      this.selectedOption.splice(index,1);
    }
  }


  checkedForTickOption(opt:any){
    let index = this.selectedOption.find((va:any) => (va['keyId'] === opt['keyId'] && va['name'] === opt['name']));
    return index ? true : false;
  }

  getSelectedTopcutOptionsText(){
    if(!this.selectedOption.length){
      return 'Please Select';
    }else{
      let text = "";
      this.selectedOption.map((va:any) =>{
        text += va['name'];
        text += ',';
      })
      return text.length > 15 ? text.substring(0,14) + '....' : text.substring(0,text.length-1);
    }
  }

  SaveTopCutColumn(){
    if(!this.topcutHeaderText){
      this.notifier.notify('error','Please Enter Header Text');
    }
    else if(this.selectedOption.length == 0){
      this.notifier.notify('error','Select at least one option');
    }else{
      let newAdCoulmn = {};
      newAdCoulmn['isNew'] = true;
      newAdCoulmn['type'] = 'level';
      newAdCoulmn['color'] = '#fff';
      newAdCoulmn['radientColor'] = '#fff';
      newAdCoulmn['name'] = this.topcutHeaderText;
      newAdCoulmn['mergerows'] = 0;
      newAdCoulmn['mergecols'] = 1;
      newAdCoulmn['options'] = {};
      this.selectedOption.forEach((va:any) =>{
        Object.keys(this.selectedTopcut['options']).forEach((key:any) =>{
          if(key === va['keyId']){
            newAdCoulmn['options'][key] = this.selectedTopcut['options'][key];
            delete this.selectedTopcut['options'][key];
          }
        })
      })

      this.selectedTopcut['options'][this.topcutHeaderText] = newAdCoulmn;
      this.evService.saveAddedColumnTopCut();
      // console.log(this.selectedTopcut);

    }
    

  }
}
